<script>
import { cn } from "$lib/utils";

let className = "";
export { className as class };
const _class = cn("section", "py-10", className);
</script>

<section class={_class}>
  <slot />
</section>
